import { Button, Card, LinearProgress, Stack, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";


export default function MainWindow(props) {
    const { onConnect, onUpdate, connected, progress, updating } = props;
    
    const handleDownloadExtension = () => {
      // Download der lokal gehosteten mBlock Extension
      const link = document.createElement('a');
      link.href = '/rita-mblock-extension-v2.mext';
      link.download = 'rita-mblock-extension-v2.mext';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    return (
      <div>
        {/* Stack which centers its childs */}
        <Stack justifyContent="center" alignItems="center" spacing={2} style={{marginTop: "2rem"}}>
            
            <Typography variant="h4" gutterBottom>
                rita.library Updater
            </Typography>
            <Card style={{padding: "2rem", minWidth: "300px", maxWidth: "600px"}}>
                <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
                <Button variant="contained" color="primary" onClick={onConnect} disabled={connected} style={{marginBottom: "1rem"}}>
                    Connect
                </Button>
                <Button variant="contained" color="primary" onClick={onUpdate} disabled={!connected || updating} style={{marginBottom: "1rem"}}>
                    Update
                </Button>
                </Stack>
                <LinearProgress variant="determinate" value={progress} style={{marginBottom: "1rem"}}/>
                <Typography variant="h5" gutterBottom>
                    Anleitung
                </Typography>

                <Typography variant="body2" gutterBottom style={{marginBottom: "1rem", lineHeight: "1.8"}}>
                    <strong>rita.library auf die rita spielen:</strong><br/>
                    1. Verbinde deine rita mit einem USB-C Kabel mit dem Laptop <br/>
                    2. Schalte die rita an <br/>
                    3. Klicke auf "Connect" um eine Verbindung zur rita herzustellen <br/>
                    4. Klicke auf "Update" um die neuste Version der rita.library auf die rita zu spielen <br/>
                    5. Warte bis der Vorgang abgeschlossen ist und trenne dann die Verbindung <br/>
                </Typography>

                <hr style={{margin: "1.5rem 0", border: "none", borderTop: "1px solid #ddd"}} />

                <Typography variant="body2" gutterBottom style={{marginBottom: "1rem", lineHeight: "1.8", marginTop: "1rem"}}>
                    <strong>mBlock Extension installieren:</strong><br/>
                    <Button 
                        variant="contained" 
                        color="success" 
                        onClick={handleDownloadExtension}
                        startIcon={<DownloadIcon />}
                        fullWidth
                        style={{marginBottom: "1rem", marginTop: "0.5rem"}}
                    >
                        Extension herunterladen
                    </Button>
                    <ol style={{marginTop: "0.5rem", paddingLeft: "1.5rem"}}>
                        <li>Lade die Extension mit dem Button oben herunter</li>
                        <li>Öffne mBlock 5 (lade es von <a href="https://mblock.cc" target="_blank" rel="noopener noreferrer">mblock.cc</a> herunter, falls du es noch nicht hast)</li>
                        <li>Ziehe die heruntergeladene Extension-Datei einfach aus dem File-Explorer in das mBlock Fenster</li>
                        <li>Nach dem Import findest du die rita.library Blöcke in der Blockpalette</li>
                    </ol>
                </Typography>
            </Card>
        </Stack>
      </div>
    );
  }